import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Retargeting Placement',
    entityNamePlural: 'Retargeting Placement',
    entityNameModule: 'path',
    basePath: '/path/retargeting',
    enableTableResize: false,
  }), [])
}
